import type { IPlayjectorService } from '../../../services/playjector/interfaces/IPlayjectorService';

/** Waits for the tracked process to release its files before the owner restores them. */
export class GameProcessStopManager {
  constructor(private readonly playjector: IPlayjectorService) {}

  public async stopBeforeRestore(hostAuthId: string): Promise<void> {
    if (!this.playjector.getCurrentState().gameLaunched) return;
    await new Promise<void>((resolve, reject) => {
      let settled = false;
      let unsubscribe: () => void = () => undefined;
      const finish = (error?: Error) => {
        if (settled) return;
        settled = true;
        clearTimeout(timeout);
        unsubscribe();
        if (error) reject(error);
        else resolve();
      };
      const timeout = setTimeout(() => finish(new Error(
        'Timed out waiting for the running game to stop before restoring its save')), 30_000);
      try {
        unsubscribe = this.playjector.onStateChange((state) => {
          if (!state.gameLaunched) finish();
        });
        if (settled) { unsubscribe(); return; }
        this.playjector.terminateGame(hostAuthId);
        if (!this.playjector.getCurrentState().gameLaunched) finish();
      } catch (error) {
        finish(error instanceof Error ? error : new Error(String(error)));
      }
    });
  }
}
